import { useState } from "react";
import DOMPurify from 'dompurify';
// import classNames from "classnames";
// import { Button, Stack, Typography } from "components";
import { Voucher } from "types";
import { formatDate } from "helpers";
import styles from "./VoucherCard.module.css";

type VoucherKeys =
  | "name"
  | "description"
  | "discount"
  | "count"
  | "available"
  | "endAt"
  | "balanceDescription";

interface VoucherCardProps extends Pick<Voucher, VoucherKeys> {
  active: boolean;
  onClick(): void;
}

const VoucherCard: React.FC<VoucherCardProps> = ({
  name,
  description,
  discount,
  count,
  available,
  endAt,
  active,
  balanceDescription,
  onClick,
}) => {
  const [buttonHover] = useState(false);
  // const [hover, setHover] = useState(false);

  const isAvailable = available > 0;
  // const availableText = `${available}/${count} available`;
  const buttonText = active ? (buttonHover ? "Unuse" : "Used") : "Use Now";
  // const discountLine = `${discount}% off`;
  const expiryDate = formatDate(endAt, { dateStyle: "short" });
  const expiryText = `Valid until\n${expiryDate}`;
  
  const sanitizeData = () => ( {
    __html: DOMPurify.sanitize(description ?? "")
  } ) 

  return (
    <>
      {/* {
        count === 10 ? 
        <div className={styles.container} style={{ minHeight: "280px"}}>
          <div className={styles.topSection} style={{ borderBottom: "1px dotted #005CC7"}}>
            <h3 className={styles.title}>PLDT Home Health Pass</h3>
            <p className={styles.typo}>Once (1) Health pass is equivalent to One (1) Consult Now only.</p>
            <p className={styles.typo}>1 of 1 Consultation Remaining</p>
            <p className={styles.typoValid}>Valid until: 12/31/2023</p>
            <button className={styles.useNowBtn}>Use now</button>
            <span className={styles.leftHoleHalf}></span>
            <span className={styles.leftHoleHalfOverlay}></span>
            <span className={styles.rightHoleHalf}></span>
            <span className={styles.rightHoleHalfOverlay}></span>
          </div>
          <div className={styles.botSection}>
            <h3 className={styles.title}>Lifeline 16-911 Emergency Quick Response Pass</h3>
            <p className={styles.typo}>1 Ambulance Rice</p>
            <p className={styles.typoValid}>Valid until: 12/31/2023</p>
            <button className={styles.claimNowBtn}>Claim Now</button>
            <span className={styles.leftHoleQrtr}></span>
            <span className={styles.leftHoleQrtrOverlay}></span>
            <span className={styles.rightHoleQrtr}></span>
            <span className={styles.rightHoleQrtrOverlay}></span>
          </div>
        </div>  :
        <div className={styles.container}>
          <div className={styles.topSection}>
            <h3 className={styles.title}>PLDT Home Health Pass</h3>
            <p className={styles.typo}>Once (1) Health pass is equivalent to One (1) Consult Now only.</p>
            <p className={styles.typo}>1 of 1 Consultation Remaining</p>
            <p className={styles.typoValid}>Valid until: 12/31/2023</p>
            <button className={styles.useNowBtn}>Use now</button>
            <span className={styles.leftHoleHalf}></span>
            <span className={styles.leftHoleHalfOverlay}></span>
            <span className={styles.rightHoleHalf}></span>
            <span className={styles.rightHoleHalfOverlay}></span>
          </div>
        </div> 
      } */}
      <div className={styles.container}>
        <div className={styles.topSection}>
          <span className={styles.title}>{name}</span>
          <div style={{ display: "flex", flexDirection: "column", gap: 2}}>
            <span className={styles.typo} dangerouslySetInnerHTML={sanitizeData()}></span>
            <span className={styles.typo}>{balanceDescription}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <p className={styles.typoValid}>{expiryText}</p>
            <button 
              className={styles.useNowBtn}
              disabled={!isAvailable}
              // color={active || !isAvailable ? "#757575" : "#43C8FB"}
              style={{ 
                fontWeight: 400, 
                backgroundColor: active || !isAvailable ? "#757575" : "#43C8FB",
                cursor: active || !isAvailable ? "not-allowed" : "pointer"
              }}
              onClick={() => {
                if(active || !isAvailable) {
                  return true;
                } else {
                  return onClick();
                }
              }}
            >{buttonText}</button>
          </div>
          <span className={styles.leftHoleHalf}></span>
          <span className={styles.leftHoleHalfOverlay}></span>
          <span className={styles.rightHoleHalf}></span>
          <span className={styles.rightHoleHalfOverlay}></span>
        </div>
      </div> 
      {/* <div className={classNames(styles.container, active && styles.active)}>
        {hover && (
          <span className={styles.tooltip}>
            <Stack direction="column" gap={0.5}>
              <Stack placeContent="space-between">
                <Typography size={-2}>{name}</Typography>
                <Typography size={-2}>{availableText}</Typography>
              </Stack>
              <Typography size={-2}>{description}</Typography>
            </Stack>
            <span className={styles.triangle} />
          </span>
        )}
        <Stack
          direction="column"
          gap={0.5}
          placeContent="center"
          placeItems="center"
          style={{
            textAlign: "center",
            padding: "16px",
            borderRight: "dashed 2px white",
            position: "relative",
          }}
        >
          <Typography
            size={0}
            color={isAvailable ? "#e65100" : "#757575"}
            weight={500}
            align="center"
            whiteSpace="pre"
            style={{ width: "6ch" }}
          >
            {discountLine}
          </Typography>
          <Typography size={-2} color="#757575" whiteSpace="pre">
            {expiryText}
          </Typography>
          <span className={styles.topHole} />
          <span className={styles.bottomHole} />
        </Stack>
        <Stack
          placeItems="center"
          style={{ padding: "16px", overflow: "hidden", flex: 1 }}
        >
          <Stack
            gap={0.5}
            direction="column"
            placeContent="center"
            style={{ overflow: "hidden", flex: 1 }}
          >
            <Typography
              size={0}
              weight={500}
              whiteSpace="pre"
              style={{ overflow: "hidden", textOverflow: "ellipsis", color: "#00427E" }}
            >
              {name}
            </Typography>
            <Stack>
              <Stack direction="column" gap={0.5} style={{ flex: 1 }}>
                <span
                  className={styles.hoverable}
                  onMouseOver={() => setHover(true)}
                  onMouseOut={() => setHover(false)}
                  onFocus={() => setHover(true)}
                  onBlur={() => setHover(false)}
                  tabIndex={0}
                >
                  <Typography
                    size={-2}
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      color: "#5E6D7D"
                    }}
                  >
                    {description}
                  </Typography>
                </span>
              </Stack>
            </Stack>
            <Stack placeContent="space-between" placeItems="center">
              <Typography
                size={-2}
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  color:"#00427E"
                }}
              >
                Valid until: 12/31/2023
              </Typography>
              <Button
                filled
                size="small"
                disabled={!isAvailable}
                color={active || !isAvailable ? "#757575" : "#43C8FB"}
                style={{ fontWeight: 400}}
                onClick={onClick}
                onHover={setButtonHover}
              >
                {buttonText}
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </div>       */}
    </>
  );
};

export { VoucherCard };
